import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Message } from 'primeng/api';
import { Zona } from '../../_models/zona';
import { ZonaBarrio } from '../../_models/zona-barrio';
import { ActivatedRoute, Params } from '@angular/router';
import { ZonaService } from '../../_services/zona.service';
import { ZonaBarrioService } from '../../_services/zona-barrio.service';
import { Location } from '@angular/common';

@Component( {
  selector: 'app-zonas-detalle',
  templateUrl: 'zonas-detalle.component.html',
} )

export class ZonasDetalleComponent implements OnInit {

  @Input() zone: Zona = new Zona();
  @Output() cerrar: EventEmitter<boolean> = new EventEmitter();
  msgs: Message;
  zonesBarrios: ZonaBarrio[] = [];
  cargando = true;
  carInformacionInicial = true;

  constructor( private route: ActivatedRoute,
               private location: Location,
               private zonesService: ZonaService,
               private zonesBarriosService: ZonaBarrioService ) {
  }

  ngOnInit() {
    // this.route.params.subscribe( ( params: Params ) => {
      // this.zonesService.get( +params[ 'id' ] ).subscribe( rs => {
        // this.zone = rs;
        this.zonesBarriosService.getAllByZonaFull( this.zone.idZona ).subscribe( data => {
          if ( data.length > 0 ) {
            this.zonesBarrios = data.filter( item => item.indicadorHabilitado );
          }
          this.carInformacionInicial = false;
          this.cargando = false;
        } );
      // } );
    // } );
  }

  goBack(): void {
    // this.location.back();
    this.cerrar.emit(false);
  }

}
